import { Stack, StackProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledStack = styled(Stack)<StackProps>(
  ({ theme: { spacing, palette, customVars } }) => ({
    gap: spacing(3.2),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minWidth: 'fit-content',
    padding: spacing(1.4, 1.6),
    marginBottom: spacing(0.2),
    backgroundColor: palette.common.white,
    boxShadow: customVars.dropDownShadow,
    '& .account-id': {
      minWidth: spacing(10),
      color: palette.text.primary,
    },
    '& .user-name': {
      minWidth: spacing(20),
      color: palette.text.primary,
    },
    '& .phone-number': {
      minWidth: spacing(15),
      color: palette.text.primary,
    },
    '& .voice-provider': {
      minWidth: spacing(19),
      color: palette.text.primary,
    },
    '& .is-tpr': {
      minWidth: spacing(8),
      color: palette.text.primary,
    },
    '& .pending-deactivation': {
      minWidth: spacing(20),
      color: palette.text.primary,
    },
    '& .is-account-active': {
      minWidth: spacing(15),
      color: palette.text.primary,
    },
    '& .has-power-dialer': {
      minWidth: spacing(15),
      color: palette.text.primary,
    },
  })
);
